export const initUserConsentCancellationRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/user-consent-cancellation",
          name: "user-consent-cancellation",
          component: () => import("@/pages/manage/user-consent-cancellation/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
        {
          path: "/manage/user-consent-cancellation/:id",
          name: "user-consent-cancellation-id",
          component: () => import("@/pages/manage/user-consent-cancellation/id.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
      ];
